import QuestionConfiguration from './QuestionConfiguration'

import './style.scss'

export { QuestionConfiguration }
export default QuestionConfiguration
